import React, { useRef } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  formatDate,
  formatDateNew,
  formatDateWithTime,
} from "../../constants/DateUtil/DateUtil";
import { OverlayPanel } from "primereact/overlaypanel";
import PaymentGatewayLinkGenerateModal from "./PaymentGatewayLinkGenerateModal";
import RefundAmountModal from "./RefundAmountModal";
import RefundAmountAdminModal from "./RefundAmountAdminModal";
import PaymentGatewayLinkGenerateModalAdmin from "./PaymentGatewayLinkGenerateModalAdmin";
import { getStoreLocalData } from "../../utils/localStorage";

const OrderInfoCard = ({
  customerOrdersData,
  storeCustomerId,
  bookingOrderId,
  userRole,
  storeId,
  enabledChargeDiscountByService,
  enabledCustomDiscountCharge,
  storeUserId,
  brandId,
  enabledCreatePaymentLink,
  updateOrderGarmentInfoPage,
  b2BChallanOrder,
  enabledAmountRoundOff
}) => {
  const navigate = useNavigate();
  const orderDetails = customerOrdersData;

  const [show, setShow] = useState(false);

  const { storeLocalData } = getStoreLocalData();

  const op = useRef(null);

  const handleShowHide = () => {
    setShow(!show);
  };

  const [
    paymentGatewayLinkGenerateModalVisible,
    setPaymentGatewayLinkGenerateModalVisible,
  ] = useState(false);

  const [refundModalVisible, setRefundModalVisible] = useState(false);

  const orderInfoDetails = {
    orderNo: orderDetails?.orderNo ? orderDetails?.orderNo : "N/A",
    invoiceNo: orderDetails?.invoiceNo ? orderDetails?.invoiceNo : "N/A",
    grandTotal: orderDetails?.grandTotal ? Number(orderDetails?.grandTotal?.toFixed(enabledAmountRoundOff)) : 0,
    paidAmount: orderDetails?.paidAmount ? Number(orderDetails?.paidAmount?.toFixed(enabledAmountRoundOff)) : 0,
    refundAmount: orderDetails?.refundAmount ? Number(orderDetails?.refundAmount?.toFixed(enabledAmountRoundOff)) : "",
    gstAmount: orderDetails?.gstAmount ? Number(orderDetails?.gstAmount?.toFixed(enabledAmountRoundOff)) : 0,
    balanceAmount: orderDetails?.balanceAmount
      ? Number(orderDetails?.balanceAmount?.toFixed(enabledAmountRoundOff))
      : 0,
    deliveryOn: orderDetails?.deliveryOn ? orderDetails?.deliveryOn : "N/A",
    deliveredOn: orderDetails?.deliveredOn ? orderDetails?.deliveredOn : "N/A",
    status: orderDetails?.status ? orderDetails?.status : "N/A",
    chargeAmount: orderDetails?.chargeAmount
      ? Number(orderDetails?.chargeAmount?.toFixed(enabledAmountRoundOff)) + Number(orderDetails?.totalDeliveryCharge?.toFixed(enabledAmountRoundOff))
      : 0,
    deliveryRequest: orderDetails?.deliveryRequest === true ? "Yes" : "No",
    discountAmount:
      Number(Number(orderDetails?.discountAmount?.toFixed(enabledAmountRoundOff)) +
        Number(orderDetails?.totalDeliveryDiscount?.toFixed(enabledAmountRoundOff)) +
        Number(orderDetails?.offerDiscount?.toFixed(enabledAmountRoundOff)) +
        Number(orderDetails?.loyaltyPointDiscount?.toFixed(enabledAmountRoundOff)) +
        Number(orderDetails?.subscriptionDiscount?.toFixed(enabledAmountRoundOff)))?.toFixed(enabledAmountRoundOff),
    offerDiscount: Number(orderDetails?.offerDiscount?.toFixed(enabledAmountRoundOff)),
    discountAmountValue: Number(orderDetails?.discountAmount?.toFixed(enabledAmountRoundOff)),
    totalDeliveryDiscount: Number(orderDetails?.totalDeliveryDiscount?.toFixed(enabledAmountRoundOff)),
    subscriptionDiscount: Number(orderDetails?.subscriptionDiscount?.toFixed(enabledAmountRoundOff)),
    loyaltyPointDiscount: Number(orderDetails?.loyaltyPointDiscount?.toFixed(enabledAmountRoundOff)),
    //   ? orderDetails?.discountAmount + orderDetails?.totalDeliveryDiscount
    //   : 0,
    // discountAmount: orderDetails?.discountAmount
    //   ? orderDetails?.discountAmount
    //   : 0,
    itemGarmentCount: orderDetails?.itemGarmentCount,
    createdDate: orderDetails?.createdDate
      ? orderDetails?.createdDate
      : "2023-11-17T12:26:36Z",
  };

  const displayDeliveryDateText =
    orderInfoDetails.status === "DELIVERED" ||
      orderInfoDetails.status === "DONE"
      ? "Delivered On"
      : "Delivery Date";
  const displayDate =
    orderInfoDetails.status === "DELIVERED" ||
      orderInfoDetails.status === "DONE"
      ? formatDateWithTime(orderInfoDetails.deliveredOn)
      : formatDateNew(orderInfoDetails.deliveryOn);

  const formattedCreatedDate = formatDateWithTime(orderInfoDetails.createdDate);
  // const formattedDeliveredOnDate = formatDate(displayDate);
  const formattedDeliveredOnDate = displayDate;
  // const formattedLastModificationOnDate = formatDate(
  //   orderInfoDetails.lastModifiedDate,
  // );

  return (
    <div className="flex-1 ">
      <div className="m-4 shadow-4">
        <div className="flex flex-1">
          <div
            className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#F8FFEE",
            }}
          >
            <p
              className="text-md font-normal capitalize"
              style={{ color: "#75879B" }}
            >
              Order No. :
            </p>
            <p className="text-xl font-medium capitalize">
              {orderInfoDetails.orderNo}
            </p>
          </div>
          <div
            className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#E2F4F8",
            }}
          >
            <p
              className="text-md font-normal capitalize"
              style={{ color: "#75879B" }}
            >
              Home Delivery :
            </p>
            <p className="text-xl font-medium capitalize">
              {orderInfoDetails.deliveryRequest}
            </p>
          </div>
        </div>
        <div className="flex flex-1">
          <div
            className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#E2F4F8",
            }}
          >
            <p
              className="text-md font-normal capitalize"
              style={{ color: "#75879B" }}
            >
              Invoice No. :
            </p>
            <p className="text-xl font-medium capitalize">
              {orderInfoDetails.invoiceNo}
            </p>
          </div>
          <div
            className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#F8FFEE",
            }}
          >
            <div className="flex flex-row justify-content-between">
              <div>
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Amt Info :
                </p>
                <p className="text-xl font-medium capitalize">
                  {storeLocalData?.currencySymbol} {orderInfoDetails.grandTotal}
                </p>
              </div>
              <div>
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  {storeLocalData?.taxType} Info :
                </p>
                <p className="text-xl font-medium capitalize">
                  {storeLocalData?.currencySymbol} {orderInfoDetails.gstAmount}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-1">
          <div
            className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#F8FFEE",
            }}
          >
            <div className="flex justify-content-between">
              <div>
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Paid Info :
                </p>
                <p className="text-xl font-medium capitalize">
                  {storeLocalData?.currencySymbol} {orderInfoDetails.paidAmount}
                </p>
              </div>
              {orderInfoDetails.refundAmount > 0 && (
                <div>
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Refund Amt :
                  </p>
                  <p className="text-xl font-medium capitalize">
                    {storeLocalData?.currencySymbol} {orderInfoDetails.refundAmount}
                  </p>
                </div>
              )}
            </div>
          </div>
          <div
            className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#E2F4F8",
            }}
          >
            <div className="flex flex-row justify-content-between">
              <div>
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Balance Amt :
                </p>
                <p className="text-xl font-medium capitalize">
                  {storeLocalData?.currencySymbol} {orderInfoDetails.balanceAmount}
                </p>
              </div>
              {orderInfoDetails.balanceAmount < 0 && (
                <div className="text-center">
                  <div
                    className="cursor-pointer"
                    onClick={() => setRefundModalVisible(true)}
                  >
                    <img
                      src={"images/cashless-payment.png"}
                      style={{
                        width: 34,
                        height: 34,
                        alignSelf: "center",
                      }}
                    />
                  </div>
                  <p
                    className="font-lg font-bold text-center"
                    style={{ color: "red" }}
                  >
                    Refund
                  </p>
                </div>
              )}
              {enabledCreatePaymentLink &&
                orderInfoDetails.balanceAmount > 0 && (
                  <div className="text-center">
                    <div
                      className="cursor-pointer"
                      onClick={() =>
                        customerOrdersData.appliedSubscriptionDiscount ===
                        false &&
                        customerOrdersData.subscriptionDiscount === 0 && setPaymentGatewayLinkGenerateModalVisible(true)
                      }
                    >
                      {customerOrdersData.appliedSubscriptionDiscount &&
                        customerOrdersData.subscriptionDiscount > 0 ? (
                        <img
                          src={"Icons/lock.png"}
                          style={{
                            width: 34,
                            height: 34,
                            backgroundColor: "transparent",
                          }}
                        />
                      ) : (
                        <img
                          src={"images/cashless-payment.png"}
                          style={{
                            width: 34,
                            height: 34,
                            alignSelf: "center",
                          }}
                        />
                      )}

                    </div>
                    <p
                      className="font-lg font-bold text-center"
                      style={{ color: "red" }}
                    >
                      Payment Link
                    </p>
                  </div>
                )}
            </div>
          </div>
        </div>
        <div className="flex flex-1">
          <div
            className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#E2F4F8",
            }}
          >
            <p
              className="text-md font-normal capitalize"
              style={{ color: "#75879B" }}
            >
              Booking Date :
            </p>
            <p className="text-xl font-medium capitalize">
              {formattedCreatedDate}
            </p>
          </div>
          <div
            className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#F8FFEE",
            }}
          >
            <p
              className="text-md font-normal capitalize"
              style={{ color: "#75879B" }}
            >
              {displayDeliveryDateText} :
            </p>
            <p className="text-xl font-medium capitalize">
              {formattedDeliveredOnDate}
            </p>
          </div>
        </div>

        <div className="flex flex-1">
          <div
            className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#F8FFEE",
            }}
          >
            <div
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <div className="flex">
                  <p
                    className="text-md font-normal capitalize mr-3"
                    style={{ color: "#75879B" }}
                  >
                    Charge{" "}
                  </p>
                  {!b2BChallanOrder &&
                    <div>
                      {userRole !== "BY_SUPPORT_ADMIN" &&
                        <div>
                          {![
                            // "DONE",
                            "CANCEL",
                          ].includes(orderInfoDetails.status) &&
                            <div
                              onClick={() => {
                                navigate("/BookingChargesInfo", {
                                  state: {
                                    storeCustomerId: storeCustomerId,
                                    bookingOrderId: bookingOrderId,
                                    storeId: storeId,
                                    enabledChargeDiscountByService:
                                      enabledChargeDiscountByService,
                                  },
                                });
                              }}
                            >
                              <i
                                className="pi pi-eye"
                                style={{
                                  fontSize: "20px",
                                  cursor: "pointer",
                                  color: "#2B70D7",
                                }}
                              ></i>
                            </div>}
                        </div>}
                    </div>
                  }
                </div>
                <p className="text-xl font-medium capitalize">
                  {storeLocalData?.currencySymbol} {orderInfoDetails.chargeAmount}
                </p>
              </div>
            </div>
          </div>
          <div
            className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#E2F4F8",
            }}
          >
            <div
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <div className="flex justify-content-between">
                  <div className="flex">
                    <p
                      className="text-md font-normal capitalize mr-3"
                      style={{ color: "#75879B" }}
                    >
                      Discount{" "}
                    </p>
                    <div onClick={(e) => op.current.toggle(e)}>
                      <i
                        className={!show ? "pi pi-eye" : "pi-eye-slash"}
                        style={{
                          fontSize: "20px",
                          cursor: "pointer",
                          color: "#2B70D7",
                        }}
                      ></i>
                    </div>
                  </div>
                  {!b2BChallanOrder &&
                    <div>
                      {userRole !== "BY_SUPPORT_ADMIN" && <div>
                        {![
                          // "DONE",
                          "CANCEL",
                        ].includes(orderInfoDetails.status) &&
                          <div
                            onClick={() => {
                              navigate("/BookingDiscountInfo", {
                                state: {
                                  storeCustomerId: storeCustomerId,
                                  bookingOrderId: bookingOrderId,
                                  storeId: storeId,
                                  enabledCustomDiscountCharge:
                                    enabledCustomDiscountCharge,
                                },
                              });
                            }}
                          >
                            <i
                              className="pi pi-pencil"
                              style={{
                                fontSize: "20px",
                                cursor: "pointer",
                                color: "#2B70D7",
                              }}
                            ></i>
                          </div>}
                      </div>}
                    </div>
                  }
                </div>
                <p className="text-xl font-medium capitalize">
                  {storeLocalData?.currencySymbol} {orderInfoDetails.discountAmount}
                </p>
              </div>
              {orderDetails?.subscriptionDiscount > 0 &&
                orderDetails?.appliedSubscriptionDiscount === false && (
                  <div>
                    <p
                      className="text-md font-medium capitalize"
                      style={{ color: "red" }}
                    >
                      * T&C Applied
                    </p>
                  </div>
                )}
            </div>
          </div>
          <OverlayPanel ref={op}>
            <div>
              <div>
                <div className="flex-row justify-content-between">
                  <p className="text-xl font-medium capitalize mr-3 text-black-alpha-90">
                    Discount{" "}
                  </p>
                  <p className="text-xl font-medium capitalize text-black-alpha-90">
                    {storeLocalData?.currencySymbol}
                  </p>
                </div>
                {orderInfoDetails.offerDiscount > 0 && (
                  <div className="flex-row justify-content-between">
                    <p
                      className="text-lg font-normal capitalize mr-3"
                      style={{ color: "#75879B" }}
                    >
                      Offer :
                    </p>
                    <p className="text-xl font-medium capitalize text-black-alpha-90">
                      {" "}
                      {orderInfoDetails.offerDiscount}
                    </p>
                  </div>
                )}
                {orderInfoDetails.discountAmountValue > 0 && (
                  <div className="flex-row justify-content-between">
                    <p
                      className="text-lg font-normal capitalize mr-3"
                      style={{ color: "#75879B" }}
                    >
                      Booking :{" "}
                    </p>
                    <p className="text-xl font-medium capitalize text-black-alpha-90">
                      {orderInfoDetails.discountAmountValue}
                    </p>
                  </div>
                )}
                {orderInfoDetails.totalDeliveryDiscount > 0 && (
                  <div className="flex-row justify-content-between">
                    <p
                      className="text-lg font-normal capitalize mr-3"
                      style={{ color: "#75879B" }}
                    >
                      Delivery :
                    </p>
                    <p className="text-xl font-medium capitalize text-black-alpha-90">
                      {" "}
                      {orderInfoDetails.totalDeliveryDiscount}
                    </p>
                  </div>
                )}
                {orderInfoDetails.subscriptionDiscount > 0 && (
                  <div className="flex-row justify-content-between">
                    <p
                      className="text-lg font-normal capitalize mr-3"
                      style={{ color: "#75879B" }}
                    >
                      Subscription :
                    </p>
                    <p className="text-xl font-medium capitalize text-black-alpha-90">
                      {" "}
                      {orderInfoDetails.subscriptionDiscount}
                    </p>
                  </div>
                )}
                {orderInfoDetails.loyaltyPointDiscount > 0 && (
                  <div className="flex-row justify-content-between">
                    <p
                      className="text-lg font-normal capitalize mr-3"
                      style={{ color: "#75879B" }}
                    >
                      Loyalty Point :
                    </p>
                    <p className="text-xl font-medium capitalize text-black-alpha-90">
                      {" "}
                      {orderInfoDetails.loyaltyPointDiscount}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </OverlayPanel>
        </div>

        {(
          <div className="flex flex-1">
            <div
              className="flex-1 px-3 py-1 flex-row justify-content-between"
              style={{
                backgroundColor: "#E2F4F8",
              }}
            >
              <p
                className="text-2xl font-medium capitalize"
                style={{ color: "red" }}
              >
                Order Challan{" "}
              </p>
              <div
                className="cursor-pointer"
                onClick={() => {
                  navigate("/RiderChallanComponent", {
                    state: {
                      storeId: storeId,
                      storeCustomerId: storeCustomerId,
                      bookingOrderId: bookingOrderId,
                      customerOrdersData: customerOrdersData,
                    },
                  });
                }}
              >
                <img
                  src={"Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png"}
                  style={{
                    width: 34,
                    height: 34,
                  }}
                />
              </div>
            </div>

            <div
              className="flex-1 px-3 py-1"
              style={{
                backgroundColor: "#F8FFEE",
              }}
            >
              <p
                className="text-md font-normal capitalize"
                style={{ color: "#75879B" }}
              >
                Total Garments :
              </p>
              <p className="text-xl font-medium capitalize">
                {orderInfoDetails.itemGarmentCount}
              </p>
            </div>
          </div>
        )}
        {orderInfoDetails.editBy && (
          <div className="flex flex-1">
            <div
              className="flex-1 px-3 py-1"
              style={{
                backgroundColor: "#F8FFEE",
              }}
            >
              <p
                className="text-md font-normal capitalize"
                style={{ color: "#75879B" }}
              >
                Edited By :
              </p>
              <p className="text-xl font-medium capitalize">
                {orderInfoDetails.editBy}
              </p>
            </div>
            <div
              className="flex-1 px-3 py-1"
              style={{
                backgroundColor: "#F8FFEE",
              }}
            >
              <p
                className="text-md font-normal capitalize"
                style={{ color: "#75879B" }}
              >
                Last Modification Date :
              </p>
              <p className="text-xl font-medium capitalize">
                {formattedDeliveredOnDate}
              </p>
            </div>
          </div>
        )}
      </div>
      {userRole === "BY_STORE" ?
        enabledCreatePaymentLink &&
        orderInfoDetails.balanceAmount > 0 && (<PaymentGatewayLinkGenerateModal
          paymentGatewayLinkGenerateModalVisible={
            paymentGatewayLinkGenerateModalVisible
          }
          setPaymentGatewayLinkGenerateModalVisible={
            setPaymentGatewayLinkGenerateModalVisible
          }
          receiveAmountValue={orderInfoDetails.balanceAmount}
          storeCustomerId={storeCustomerId}
          storeId={storeId}
          brandId={brandId}
          storeUserId={storeUserId}
          bookingOrderId={bookingOrderId}
        />) :
        orderInfoDetails.balanceAmount > 0 && (<PaymentGatewayLinkGenerateModalAdmin
          paymentGatewayLinkGenerateModalVisible={
            paymentGatewayLinkGenerateModalVisible
          }
          setPaymentGatewayLinkGenerateModalVisible={
            setPaymentGatewayLinkGenerateModalVisible
          }
          receiveAmountValue={orderInfoDetails.balanceAmount}
          storeCustomerId={storeCustomerId}
          storeId={storeId}
          brandId={brandId}
          storeUserId={storeUserId}
          bookingOrderId={bookingOrderId}
        />)}
      {userRole === "BY_STORE" ? (
        <RefundAmountModal
          setRefundModalVisible={setRefundModalVisible}
          refundModalVisible={refundModalVisible}
          storeId={storeId}
          storeCustomerId={storeCustomerId}
          bookingOrderId={bookingOrderId}
          storeUserId={storeUserId}
          balanceAmount={orderInfoDetails.balanceAmount}
          orderInfoDetails={orderInfoDetails}
          userRole={userRole}
          updateOrderGarmentInfoPage={updateOrderGarmentInfoPage}
        />
      ) : (
        <RefundAmountAdminModal
          setRefundModalVisible={setRefundModalVisible}
          refundModalVisible={refundModalVisible}
          storeId={storeId}
          storeCustomerId={storeCustomerId}
          bookingOrderId={bookingOrderId}
          storeUserId={storeUserId}
          balanceAmount={orderInfoDetails.balanceAmount}
          orderInfoDetails={orderInfoDetails}
          userRole={userRole}
          updateOrderGarmentInfoPage={updateOrderGarmentInfoPage}
        />
      )}
    </div>
  );
};

export default OrderInfoCard;
